import cs from './cs/strings.json';
import da from './da/strings.json';
import de from './de/strings.json';
import en from './en/strings.json';
import es from './es/strings.json';
import fr from './fr/strings.json';
import frCA from './fr-CA/strings.json';
import hu from './hu/strings.json';
import it from './it/strings.json';
import ja from './ja/strings.json';
import ko from './ko/strings.json';
import nl from './nl/strings.json';
import no from './no/strings.json';
import pl from './pl/strings.json';
import pt from './pt/strings.json';
import ptBR from './pt-BR/strings.json';
import ru from './ru/strings.json';
import sv from './sv/strings.json';
import zhHans from './zh-Hans/strings.json';
import zhHant from './zh-Hant/strings.json';

const translations = {
  cs,
  da,
  de,
  en,
  es,
  fr,
  'fr-CA': frCA,
  hu,
  it,
  ja,
  ko,
  nl,
  no,
  pl,
  pt,
  'pt-BR': ptBR,
  ru,
  sv,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant
};

export default translations;
